import css from 'styled-jsx/css'

import { colors, sizes } from '../../theme'
import common from '../../theme/common'


export default css`
.container {
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  height: ${sizes.header.desktop.height};
  width: 100%;
  background: ${colors.midnightExpress};
  transition: box-shadow 150ms ease;
  padding: 0 1rem;
  z-index: 10;
}

.container.blur {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.container :global(.inner) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: ${sizes.body.desktop.maxWidth};
}

.container :global(aside) {
  margin-left: 1rem;
  margin-right: 2rem;
  height: 5.3rem;
}

.container :global(aside a) {
  height: 100%;
  transition: opacity 150ms ease;
}

.container :global(aside a:hover) {
  opacity: 0.6;
}

.container :global(aside a:active) {
  opacity: 0.4;
}

.container :global(.logo) {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.container :global(.logo img) {
  height: 3rem;
}
  
.container .right {
  display: flex;
  align-items: center;
  gap: 3.6rem;
}

.container :global(.link) {
  display: flex;
  height: 6.2rem;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 0 1rem;
  transition: opacity 150ms ease;
  overflow: hidden;
}

.container :global(.link:hover) {
  opacity: 0.6;
}

.container :global(.link:active) {
  opacity: 0.3;
}

.label {
  ${common.small};
  font-family: 'Nexa Bold', sans-serif;
  color: ${colors.pureWhite};
  display: block;
  // text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-transform: uppercase;
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  .container {
    height: ${sizes.header.mobile.height};
  }

  .container .right {
    gap: 2.4rem;
  }
}
`
